import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import BTMarketing from "../../../components/marketing/marketing-bt"
import { nextPage } from "../../../redux/actions/journey-actions"

const BTMarketingPage = ({ gotoNextPage }) => (
  <BTMarketing handleButtonClick={gotoNextPage} />
)

BTMarketingPage.propTypes = {
  gotoNextPage: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => ({
  gotoNextPage: () => dispatch(nextPage())
})

export default connect(
  null,
  mapDispatchToProps
)(BTMarketingPage)
